"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = exports.AlertMount = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./Alert.css");
var Button_1 = require("../../components/Button");
var useInterface_1 = require("../../hooks/useInterface");
var R = __importStar(require("../../utils/ramda"));
var MDIcon_1 = require("../../components/MDIcon");
exports.AlertMount = (0, react_1.forwardRef)(function (_, ref) {
  var _a = __read((0, react_1.useState)(null), 2),
    content = _a[0],
    showAlert = _a[1];
  (0, useInterface_1.useInterface)(ref, {
    showAlert: showAlert
  });
  if (!content) {
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
  }
  if (react_1.default.isValidElement(content)) {
    return content;
  }
  return (0, jsx_runtime_1.jsx)(exports.Alert, __assign({}, content));
});
(0, MDIcon_1.preloadIcons)("checkbox-marked-circle", "information", "alert-circle");
var Alert = function (_a) {
  var children = _a.children,
    _b = _a.type,
    type = _b === void 0 ? "info" : _b,
    className = _a.className,
    _c = _a.onClose,
    onClose = _c === void 0 ? R.N : _c,
    closeButtonText = _a.closeButtonText,
    _d = _a.closeType,
    closeType = _d === void 0 ? "icon" : _d,
    restProps = __rest(_a, ["children", "type", "className", "onClose", "closeButtonText", "closeType"]);
  var classes = (0, classnames_1.default)("vsx-alert-d", "vsx-".concat(type, "-alert"), className);
  var iconMap = {
    success: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
      icon: "checkbox-marked-circle",
      className: "vsx-alert-icon success"
    }),
    info: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
      icon: "information",
      className: "vsx-alert-icon info"
    }),
    warning: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
      icon: "alert-circle",
      className: "vsx-alert-icon warning"
    })
  };
  var closeButtonMap = {
    icon: (0, jsx_runtime_1.jsx)(Button_1.IconButton, {
      onClick: onClose,
      icon: "close",
      round: true
    }),
    button: (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({
      type: "secondary",
      className: "vsx-alert-close-button",
      onClick: onClose
    }, {
      children: closeButtonText
    }))
  };
  return (0, jsx_runtime_1.jsxs)("div", __assign({}, restProps, {
    role: "alert",
    className: classes
  }, {
    children: [(0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-alert-icon-container"
    }, {
      children: iconMap[type] || iconMap.info
    })), (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-alert-content"
    }, {
      children: children
    })), (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-alert-close-container"
    }, {
      children: closeButtonMap[closeType !== null && closeType !== void 0 ? closeType : "icon"]
    }))]
  }));
};
exports.Alert = Alert;